import { MutationTree } from 'vuex'
import { UserSession } from './types'
import { initialState } from './index'
import Timeout = NodeJS.Timeout;

export const mutations: MutationTree<UserSession> = {
  reset(state) { Object.assign(state, initialState) },
  sessionLoaded(state, payload: UserSession) {
    state.authenticated = payload.authenticated;
    state.error = false;
    state.user = payload.user;
    state.wss = payload.wss;
  },
  checkTimeout(state, payload: Timeout) {
    state.checkTimeout = payload;
  },
  sessionError(state) {
    state.authenticated = false;
    state.error = true;
    state.user = undefined;
    state.wss = false;
  }
};
